import { DataAttributeDefinitions } from 'scrivito'

import { pisaContactListRelationDataClass } from './Pisa/pisaContactListRelationDataClass'

const attributes: DataAttributeDefinitions = {}

export const ContactListRelation = pisaContactListRelationDataClass(attributes)
